import { CircleMarker } from "../../../types/CircleMarker.ts";
import { AcknowledgedTargetsTrainingScanRequest } from "../../../types/TrainingScan.ts";

interface ImageDimensions {
  width: number;
  height: number;
}

interface BuildAcknowledgedTargetsTrainingScanRequestParams {
  image: string;
  targetId: string;
  centerField: CircleMarker;
  acceptedHitMarkers: CircleMarker[];
  renderedImageDimensions: ImageDimensions;
  storedImageDimensions: ImageDimensions;
  shootingEventId?: string;
  sessionId?: string;
  feedback?: string;
}

export const buildAcknowledgedTargetsTrainingScanRequest = ({
  image,
  targetId,
  centerField,
  acceptedHitMarkers,
  renderedImageDimensions,
  storedImageDimensions,
  shootingEventId,
  sessionId,
  feedback
}: BuildAcknowledgedTargetsTrainingScanRequestParams): AcknowledgedTargetsTrainingScanRequest => {
  const xScaleFactor = renderedImageDimensions.width / storedImageDimensions.width;
  const yScaleFactor = renderedImageDimensions.height / storedImageDimensions.height;
  const markerRadiusScaleFactor = (xScaleFactor + yScaleFactor) / 2;

  return {
    image: image,
    targetId: targetId,
    centerField: {
      x: centerField.x / xScaleFactor,
      y: centerField.y / yScaleFactor,
      radius: centerField.radius / markerRadiusScaleFactor
    },
    acceptedHitMarkers: acceptedHitMarkers.map((hitMarker) => ({
      x: hitMarker.x / xScaleFactor,
      y: hitMarker.y / yScaleFactor,
      markerRadius: hitMarker.radius / markerRadiusScaleFactor
    })),
    ...(shootingEventId ? { shootingEventId: shootingEventId } : {}),
    ...(sessionId ? { sessionId: sessionId } : {}),
    ...(feedback ? { feedback: feedback } : {})
  };
};

export const getImageDimensions = (image: string): Promise<ImageDimensions> => {
  return new Promise((resolve, reject) => {
    const imageElement = new Image();

    imageElement.onload = () => {
      resolve({
        width: imageElement.width,
        height: imageElement.height
      });
    };

    imageElement.onerror = reject;
    imageElement.src = image;
  });
};
